/**
 * Created by desheng.zhao on 2019/2/21.
 */

// 按页面划分
export default {
  // 公共页面
  common: {
    fill: "请填写",
    fillError: "填写错误",
    fillHasError: "表单填写不完整",
    ajaxError: "数据出错了",
    networkError: "网络出错啦~",
    tokenExpire: "登录信息已失效或未登录",
  },
  //邮箱登录
  emailLogin: {
    title: '邮箱登录',
    subTitle: "邮箱登录",
    emailAccount: "邮箱",
    password: "密码",
    emailEmpty: "请填写邮箱",
    emailError: "邮箱填写错误",
    checkEmail: "请检查邮箱",
  },
  // 手机登录
  login: {
    title: "登录",
    subTitle: "手机登录",
    phoneNo: "手机号",
    password: "密码",
    msgCode: "验证码",
    getMsgCode: "获取验证码",
    getMsgInterval: "s后可重新获取", // 这里的s是秒的意思
    loginBtn: "登录",
    registerBtn: "注册",
    resetBtn: "忘记密码",
    phoneEmpty: "请填写手机号",
    phoneError: "手机号填写错误",
    checkPhone: "请检查手机号",
    fillMsgCode: "请填写手机验证码",
    fillPassword: "请填写密码",
    fill: "请填写",
    fillError: "填写错误",
    hasError: "表单填写不完整或有误",
    loginSuccess: "登录成功",
    needMsgCheck: "本次登录需要短信验证码验证",
  },
  // 注册
  register: {
    title: "注册",
    subTitle: "手机注册",
    phoneNo: "手机号码",
    password: "设置6-20位密码",
    repeatPwd: "再次确认密码",
    msgCode: "验证码",
    getMsgCode: "获取验证码",
    getMsgInterval: "s后可重新获取", // 这里的s是秒的意思
    picCode: "请输入图片识别码",
    getPicCode: "获取图片验证码",
    registerBtn: "注册",
    auth: {
      tip: "注册即表示您已阅读并同意",
      agreeMent: "用户协议",
      and: "和",
      policy: "隐私政策"
    },
    footer: "如有疑问，可在公众号中反馈",

    phoneEmpty: "请填写手机号",
    phoneError: "手机号填写错误",
    fillPassword: "请填写密码",
    pwdInvalidLetter: "密码中包含不合法的符号",
    pwdLenLow: "密码不可小于6位",
    pwdNeedLetter: "密码需包含字母或特殊符号",
    pwdNeedNum: "密码需包含数字",
    pwdLenUp: "密码长度超过最大20位限制",
    fillRepeatPwd: "请填写确认密码",
    RepeatPwdError: "两次密码不一致",
    fillMsgCode: "请填写手机验证码",
    fillPicCode: "请填写图片验证码",
    getPicCodeFirst: "请先获取图片验证码",
    registSuccess: "注册成功",
  },
  // 找回密码
  reset: { // 找回密码很多字段和注册一样，就直接调用注册的
    title: "重置密码",
    subTitle: "重置密码",
    resetBtn: "确认修改并登录",
  },
  // 登录成功
  loginSuccess: {
    title: "登录成功",
    logAccount: "账号已登录",
    toBindBtn: "去绑定设备",
    toShareBtn: "去分享流量",
    logOutBtn: "退出账号",
    footer: "若无设备，请联系公众号客服",

    isLogout: "是否要退出当前账号？",
    confirmText: "确定",
    cancelText: "取消",
    logOutSuccess: "退出账号成功",
  },
  // 绑定设备
  binding: {
    title: "绑定设备",
    imei: "设备编码：",
    fillImei: "请输入设备IMEI号",
    password: "设备密码：",
    fillPwd: "请输入设备密码",
    bindBtn: "立即绑定",
    needImei: "请填写设备编码",
    needPwd: "请填写设备密码",
  },
  // 绑定设备成功
  binded: {
    title: "绑定成功",
    bindedMachine: "已绑定设备",
    toShare: "去分享卡流量",
    unbind: "解除绑定",
    unbindSuccess: "解除绑定成功",
    isUnbind: "是否要解除设备绑定？",
    confirmText: "确定",
    cancelText: "取消",
  },
  // 卡分享详情
  shareDetail: {
    title: "卡分享详情",
    imei: "设备号",
    online: "在线",
    offline: "离线",
    tip: "温馨提示",
    footer: "如有疑问，请联系公众号客服解决",
    submitSuccessTip: "提交申请成功，客服将尽快给您审核派单，请您稍等一下，派单后需要您再次确认哦~",
    alertButtonText: "确定",
    offlineOperateTip: "设备离线状态下不可以操作哦~",
    offlineTip: "您的设备已离线，请检查设备状态，离线将影响您的卡分享收益，如有疑问，请添加以下Q群联系客服解决。",
    unbindedTip: "此设备已被解绑，请重新绑定",
    cancelSuccess: "取消成功",

    simShareInfo: { // sim-share-info
      simShareInfo: "卡分享信息",
      phone: "号码",
      flow: "分享流量",
      price: "单价",
      shareEndTime: "分享日期至",
      cancelShareBtn: "取消分享",
      confirmShareBtn: "确认分享",
    },

    simShareSuccess: {
      shareSuccess: "分享成功",
      tip: "分享期间请保持设备的开启状态，保证稳定供卡",
      alertBtnText: "确定"
    },

    submitSimInfo: {
      title: "填写分享卡的套餐信息",
      phone: "号码",
      phonePh: "请输入SIM卡的号码", // ph  placeholder
      flow: "分享流量",
      flowPh: "建议{flow}GB以下",
      flowPh1: "建议",
      flowPh2: "GB以下",
      shareEndTime: "分享日期至",
      shareEndTimePh: "分享结束日期",

      operator: "运营商",
      operatorPh: "选择运营商",
      pickerConfirmText: "确定",
      pickerCancelText: "取消",

      cancelBtn: "取消",
      submitBtn: "提交",

      needPhone: "请填写手机号",
      phoneError: "手机号填写错误",
      needFlow: "请填写分享流量额度",
      flowTip: "分享流量请输入{flow}以内的整数",
      flow1: "分享流量请输入",
      flow2: "以内的整数",
      flowCannot0: "分享流量不能为0",
      flowCannotMinus: "分享流量不能为负数",
      fillShareEndTime: "请填写分享截止时间",
      selectOperator: "请选择运营商",
    },

    oneSim: {
      dataError: "数据异常，",
      tryAgain: "刷新试试",
      loading: "加载中……",
      detectedSim: "检测到SIM卡",
      toShare: "去分享",
      detectedNoSim: "未检测到SIM卡",
      enterSim: "请插入SIM卡",
      status00: "等待分享",
      status01: "审核中",
      status02: "已配单，确认分享",
      status03: "审核失败,重新分享",
      status04: "正在分享",
      status05: "分享中断",
      status06: "重新分享",
      status07: "取消分享",
      status08: "卡业务状态异常",
    }
  },
  // 提现记录
  withdrawRecord: {
    title: "提现记录",
    totalProfit: "总收益",
    canWithdrawAmount: "可提现(元)",
    withdraw: "提现",
    withdrawRecord: "提现记录",
    withdrawAmount: "提现金额",
    moreRecord: "查看更多",
    noMoreData: "Sorry，没有新的数据哦",
    footer: "如有疑问，请联系公众号客服解决",
    cannotWithdraw: "您还未有分享的流量，赶紧去分享吧",
    noRecord: "您还没有提现记录哦~",
    contactMe: "请关注插卡宝公众号或者联系qq客服738605106"
  },
  // 提现
  withdraw: {
    title: "提现",
    canWithdrawAmountTip: "可提现金额(元)",
    withdrawPre: "￥",
    amountPh: "请输出要提现的金额",
    canWithdrawAmount: "可提现金额{amount}元",
    withdrawAll: "全部提现",
    withdrawTo: "提现到",
    wechatWallet: "微信钱包",
    sendMethod: "客服红包发放",
    nameConfirm: "身份核对：",
    namePh: "请输入您的真实姓名",
    withdrawBtn: "提现",
    tip: "客服给您打款的日期为每周五11:00~18:00（国家法定节假日除外）",
    footer: "如有疑问，请联系公众号客服解决",

    needName: "请输入您的真实姓名",
    withdrawTip: "客服已收到您的提现需求，我们将在周五给您打款。您可以加入以下QQ群寻求帮助{QQ}",
    alertButtonText: "确定",
    needAmount: "请填写提现金额",
    amountIsNaN: "提现金额只能输入数字",
    amountLg: "提现金额不可以大于可提现金额",
    twoDecimalPlaces: "最多支持两位小数",
    amountNegative: "提现金额不能为负数",
    amountIs0: "提现金额不能为0",
    usernameError: "姓名格式错误"
  },
  // 历史订单
  historyOrders: {
    title: "历史订单",
    createOrderTime: "订单时间",
    sharedFlow: "分享流量",
    moreOrder: "查看更多",
    noMoreData: "Sorry，没有新的数据哦",
    footer: "如有疑问，请联系公众号客服解决",
    noOrder: "您还未有完成订单哦，不要着急",
  },
  // 订单详情
  orderDetail: {
    title: "历史订单",
    phone: "手机号码",
    flow: "分享流量",
    createOrderTime: "订单时间",
    price: "价格规则",
    orderId: "订单单号",
    footer: "如有疑问，请联系公众号客服解决",
  },
  // 无设备
  noSim: {
    title: "卡分享详情",
    noCard: "还没有分享的流量卡哦~",
    toBind: "已有设备，去绑定",
    footer: "若无设备，请联系公众号客服",
  },
  // 设置
  setting: {
    title: "设置",
    device: "我的设备",
    language: "切换语言",
    logOut: "退出账号"
  },
  // 切换语言
  changeLanguage: {
    title: "切换语言"
  },
  // 隐私政策
  policy: {
    title: "隐私政策"
  },
  // 切换语言
  agreement: {
    title: "用户协议"
  },
  // 首页
  home: {
    title: "插卡宝",
    totalFit: "总收益金额",
    withdraw: "提现",
    withdrawHistory: "收益记录",
    historyOrder: "历史订单",
    instruction: "使用说明",
    myDevices: "我的设备",
    boxName: "SIM卡盒子",
    online: "在线",
    offline: "离线",
    imeiNum: "IMEI号",
    addDevice: "扫码添加设备",
    noDevice: "还没有绑定设备哦~",
    noFit: "暂无收益",
    noSignal: "无信号",
    profitUnit: "元",
    unknownPhone: "未识别您的机型",
    openInApp: "请在多卡宝APP中使用此功能"
  },
  reservationCode: {
    title: "插卡宝",
    inputCodeTip: "请输入您的预约码",
    noCode: "若您没有预约码请联系客服",
    codePlaceholder: "请输入您的预约码",
    btnText: "确定",
    auth: {
      tip: "确定即表示您已阅读并同意",
      agreeMent: "用户协议",
      and: "和",
      policy: "隐私政策"
    },
    validateSuccess: "验证成功",
  },
  instruction: {
    title: "使用说明",
    step1: "1、进入APP内，个人-SIM卡设置，选择“共享SIM卡”；",
    step1Remark: "(注：此时SIM卡将被设置为云卡，SIM卡设置为云卡后无法使用语音、短信等服务，在提交订单前可随时取消此状态。)",
    step2: "2、点击“立即申请”或在【个人】页面内点击“流量交易”，进入可提交订单；",
    step3: "3、【流量交易】内，可将此前所设置的SIM卡进行提交订单申请，待订单审核通过后可查看当前交易状态、金额等信息。",
    readBtn: "好的，知道了",
  },
  // 所有的过渡页面
  pages: {
    userCenter: "", // 个人中心
    myMachine: "我的设备"
  }
}



// WEBPACK FOOTER //
// ./src/lang/zh.js